export enum PlatformBillingPriceModeEnum {
    FIXED = 'fixed',
    PER_USER = 'perUser',
}
